// extracted by mini-css-extract-plugin
export default {"copy_button":"copy-button_copy_button__79acP","disabled":"copy-button_disabled__JzwlE"};